import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        color: theme.palette.secondary.main,
    },
    textIcon: {
        fontSize: 120,
        lineHeight: 1,
        marginTop: 30,
        marginBottom: theme.spacing(1),
        fontWeight: 'bold'
    },
    imageIcon: {
        width: '100%',
        height: '125px',
        marginTop: 30,
        marginBottom: theme.spacing(1),
    },
    svgIcon:{
        filter: 'invert(39%) sepia(15%) saturate(1244%) hue-rotate(180deg) brightness(90%) contrast(91%);',
    },
    title: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        padding: '0 20px 0 20px'
    },
    subTitle: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontSize: '1.2rem'
    },
    item: {},
    itemHeader: {
        width: '100%',
        height: '40px',
        lineHeight: '40px',
        paddingLeft: 5,
        textAlign: 'left',
        color: theme.palette.secondary.dark,
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: fade(theme.palette.primary.light, 0.25),
        display: 'flex',
        justifyContent: 'space-between',
    },
    itemBody: {
        padding: '0 20px 0 20px',
    },
    inputSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center'
    },
    inputLabel: {
        fontSize: '1.5rem'
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 2
    },
    asteriskError:{
        fontSize:"30px",
        color:"red"
    },
    asteriskNormal:{
        fontSize:"30px",
    }

}));

export default useStyles;